const config = {
  app: {
    baseUrl: process.env.REACT_APP_BASE_URL,
    marketplace: process.env.REACT_APP_MARKETPLACE_URL || "https://jersium.com",
  },
  api: {
    baseEndpoint: process.env.REACT_APP_API_BASE_ENDPOINT,
  },
  integrations: {
    stripe: {
      publicKey: process.env.REACT_APP_INTEGRATIONS_STRIPE_PUBLIC_KEY,
    },
  },
};

export default config;
